import styled from 'styled-components'

const FormError = styled.span`
  color: ${({ theme }) => theme.colors.negative};
  font-size: 0.875rem;
`

export default FormError
